import { push } from '@lagunovsky/redux-react-router'
import { keyBy } from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { H_CAMPAIGN_INSTALLATION_DASHBOARD } from '../../../account/constants/AccessRulesConstants'
import CampaignAction from '../../../campaign/actions/CampaignAction'
import DashboardCampaign from '../../../campaign/components/campaignDashboard/DashboardCampaign'
import ProgressCard from '../../../components/card/ProgressCard'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import { STATION_TYPE_NAME } from 'station/constants/StationConstants'
import { useParams } from 'react-router'

const InstallationCampaignDashboard = ({}) => {
    const [dataLoaded, setDataLoaded] = useState(false)
    const [progress, setProgress] = useState(0)

    const {
        installationsLight,
        campaignVisits,
    } = useSelector(store => ({
        installationsLight: store.InstallationReducer.installationsLight,
        campaignVisits: store.CampaignReducer.campaignVisits,
    }), shallowEqual)

    const { id } = useParams()
    const dispatch = useDispatch()

    useEffect(() => {
        if (!componentHasHabilitations(H_CAMPAIGN_INSTALLATION_DASHBOARD)) { // A modifier quand react-router sera à jour
            dispatch(push('/unauthorized'))
            return
        }
        dispatch(CampaignAction.loadCampaignDashboard(p => setProgress(p)))
            .then(() => setDataLoaded(true))

        if (id !== 'new') {
            dispatch(CampaignAction.fetchCampaignVisits(id))
        }
    }, [dispatch, id])

    const installations = useMemo(() => {
        if (!campaignVisits.length) return installationsLight
        const visitByInstallation = keyBy(campaignVisits, 'idInstallation')
        return installationsLight.map(installation => ({ ...installation, ...visitByInstallation[installation.id] }))
    }, [installationsLight, campaignVisits])

    if (dataLoaded) {
        return (
            <DashboardCampaign
                stations={installations}
                stationType={STATION_TYPE_NAME.installation}
            />
        )
    }
    return (
        <ProgressCard progress={progress} />
    )
}

export default InstallationCampaignDashboard
